import React from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import "../OrderOptions.scss";
import { Container, Row, Col, Form } from "react-bootstrap";
import messages from "../../../assets/i18n";
import formatCnpj from '../../../helpers/formatCnpj';

function OrderOptionsCdTab(props) {
    const { localizacaoFisica } = props;
    const lang = useSelector(state => state.language.name)
    const pageMessages = messages[lang].orderOptions.localizacaoFisica

    return (
        <Container>
            <Row>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.id}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.id}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.nome}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.nome}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.cnpj}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.cnpj ? formatCnpj(localizacaoFisica.cnpj) : ''}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.ie}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.ie}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.email}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.email}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.telefone}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.telefone}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.tipoLocalidade}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.tipoLocalidade}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.endereco}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.endereco}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.numero}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.numero}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.bairro}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.bairro}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.cidade}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.cidade}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={1} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.uf}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.uf}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.cep}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={localizacaoFisica.cep}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
        </Container>
    );
}

OrderOptionsCdTab.propTypes = {
    localizacaoFisica: PropTypes.object
};

const mapStateToProps = state => ({
    lang: state.language
});

export default connect(mapStateToProps)(OrderOptionsCdTab);